import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';

import { UserJsVm } from '../../../../shared/generated/Admin/Models/User/UserJsVm';
import { SecurityService } from './../../../security/security.service';
import { Permission } from '../../../security/generated/Permission';
import { SwapClientVm } from '../../../../shared/generated/Admin/Models/SwapClientVm';
import { NavigationService } from '../../../../shared/navigation/navigation.service';
import { NavRoute } from '../../../../shared/navigation/nav.route.interface';
import { GlobalVariablesService } from '../../../../services/global-variables.service';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'pcg-swap-client-modal'
    , templateUrl: './swap-client-modal.component.html'
    , styleUrls: ['./swap-client-modal.component.scss']
    , standalone: false
})
export class SwapClientModalComponent implements OnInit {

	user!: UserJsVm; 
	form = SwapClientVm.Form;
	model = SwapClientVm.GetModel(this.form);
	forcedNav!: NavRoute; // The nav manually selected by the user, if any
	secondaryNavMenu!: NavRoute; // The secondary nav menu that is selected

	constructor(
		public sec: SecurityService
		, public activeModal: NgbActiveModal
		, public nav: NavigationService
		, public router: Router
		, public activatedRoute: ActivatedRoute
		, public gvs: GlobalVariablesService
	) { }	

	/** Get route information and current client information to use when swapping */
	ngOnInit() {
		this.user = this.sec.getUser();
		this.model.clientId = this.user?.clientId!;
	}

	/**
	 * Reload the correct page after changing client.
	 *
	 * `swapped` is the SystemMessage `value` from api/SetClient (SwapClientVmMapper.SaveModelAsync):
	 * `{ user, security, token, ... }`. S2N-3076: a user's profile is PER AGENCY — the same person can
	 * be an Admin in one agency and View Only in the next — so the fresh `security` and `token` must
	 * be stored along with the user, exactly as app.component's saveChangeClient does. The old call
	 * kept the previous agency's permissions (and stored the whole envelope as the user).
	 */
	async reloadPage(swapped: { user: UserJsVm; security: Permission; token: string; }) {
		// setSecurity leaves a field alone when it is undefined but CLEARS it when it is null, and a JSON
		// envelope carries null (not undefined) for a missing member -- so a missing security must not
		// wipe the stored permissions.
		this.sec.setSecurity(swapped?.token, swapped?.user, swapped?.security ?? undefined!);
		if (
			this.secondaryNavMenu?.name === 'Inventory' 
			|| this.secondaryNavMenu?.parentNav?.name === 'Inventory'
		) {
			// Go to main inventory list if we are changing client from the inventories area
			await this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigateByUrl('/inventory/list'));
		} else if (this.router.url.includes('/clients/')) {
			await this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigateByUrl('/sysadmin/customers/list'));
		} else if (this.forcedNav?.path) {
			// If a nav has been manually selected with either setOpenSecondaryNav or setActiveNav, click the link that was selected
			const forcedNavPath = this.forcedNav.path;
			await this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigateByUrl('/' + forcedNavPath));
		} else {
			// Do a reload of the location selected in the nav
			const currUrl = this.router.url;
			await this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate([currUrl]));
		}

		this.activeModal.dismiss(); // Close the modal
	}
}
